import * as Yup from 'yup';
import i18next from 'i18next';

export const VersionUpdateSchema = () =>
  Yup.object().shape({
    androidVersion: Yup.string()
      .required(() => i18next.t('userModal_validationRequired'))
      .matches(/^\d+\.\d+\.\d+$/, {
        message: () => i18next.t('versionPage_errorValidation'),
        excludeEmptyString: true
      }),
    iosVersion: Yup.string()
      .required(() => i18next.t('userModal_validationRequired'))
      .matches(/^\d+\.\d+\.\d+$/, {
        message: () => i18next.t('versionPage_errorValidation'),
        excludeEmptyString: true
      })
  });
